import {
  Dispatch,
  ReactNode,
  SetStateAction,
  createContext,
  useState,
  useMemo,
} from 'react';

interface CvVideosListContextData {
  cvVideosCount: number | undefined;
  setCvVideosCount: Dispatch<SetStateAction<number | undefined>>;
  cvVideosPendingCount: number | undefined;
  setCvVideosPendingCount: Dispatch<SetStateAction<number | undefined>>;
}

export const CvVideosListContext = createContext<
  CvVideosListContextData | undefined
>(undefined);

const CvVideosListProvider = ({ children }: { children: ReactNode }) => {
  const [cvVideosCount, setCvVideosCount] = useState<number | undefined>();
  const [cvVideosPendingCount, setCvVideosPendingCount] = useState<
    number | undefined
  >();

  // Memoize the context value so it doesn't change on every render
  const contextValue = useMemo(
    () => ({
      cvVideosCount,
      setCvVideosCount,
      cvVideosPendingCount,
      setCvVideosPendingCount,
    }),
    [
      cvVideosCount,
      setCvVideosCount,
      cvVideosPendingCount,
      setCvVideosPendingCount,
    ],
  );

  return (
    <CvVideosListContext.Provider value={contextValue}>
      {children}
    </CvVideosListContext.Provider>
  );
};

export default CvVideosListProvider;
